import { IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { detailEmailTemplateApi } from "src/DAL/SiteSetting/siteSetting";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const EmailTemplatePreview = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [preview, setPreview] = useState("");

  const previewDetail = async () => {
    const result = await detailEmailTemplateApi(params.id);
    if (result.code == 200) {
      setPreview(result.email_body);
    }
  };

  useEffect(() => {
    previewDetail();
  }, []);

  return (
    <>
      <div className="container">
        <div className="row mobile-margin display-flex">
          <div className="col-12">
            <IconButton
              className="back-screen-button mb-4"
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon />
            </IconButton>
          </div>
        </div>
      </div>
      <iframe
        className="responsive-iframe"
        srcdoc={preview}
        width="1000px"
        height="1600px"
      ></iframe>
    </>
  );
};
